var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlueTickIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 86,
    viewBox: "0 0 86 86",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M73.0833 43.4998C73.0833 59.8372 59.8374 73.0832 43.5 73.0832C27.1626 73.0832 13.9167 59.8372 13.9167 43.4998C13.9167 27.1624 27.1626 13.9165 43.5 13.9165C59.8374 13.9165 73.0833 27.1624 73.0833 43.4998Z",
    fill: "#192643"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M59.1585 29.5752L39.0862 49.6712L30.7999 41.4085L26.6168 45.5916L39.0921 58.0373L63.343 33.7583L59.1585 29.5752Z",
    fill: "#01C1B7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueTickIcon);
export default __webpack_public_path__ + "static/media/blue_tick_icon.4dcae4e5093b6c617157c98307df2ade.svg";
export { ForwardRef as ReactComponent };